import { inject, NewInstance } from 'aurelia-framework';
import { SnapshotTypeService } from 'pages/system-fields/snapshot-types/service';
import { EventAggregator } from 'aurelia-event-aggregator';
import { DialogController } from 'aurelia-dialog';
import { ValidationRules, ValidationController, validateTrigger } from 'aurelia-validation';
import { BootstrapFormRenderer } from 'resources/validation-renderer';
import toastr from 'toastr';

@inject(DialogController, NewInstance.of(ValidationController), SnapshotTypeService, EventAggregator)
export class SnapshotTypeEditor {
    constructor(controller, validationController, snapshotTypeService, ea) {
        this.controller = controller;
        this.snapshotTypeService = snapshotTypeService;
        this.ea = ea;
        this.snapshotType = {};

        this.validationController = validationController;
        this.validationController.validateTrigger = validateTrigger.manual;
        this.validationController.addRenderer(new BootstrapFormRenderer());
        this.rules = ValidationRules
            .ensure('name').required()
            .rules;
    }

    async activate(model) {
        if (model?.id != null) {
            this.snapshotType = await this.snapshotTypeService.getById(model.id);
        }
    }

    attached() {
        this.uxBody.querySelector('input').focus();        
    }

    async save() {
        if (this.isRequesting) return;
        this.isRequesting = true;
        const validationResult = await this.validationController.validate();
        if (validationResult.valid) {
            try {
                if (this.snapshotType.id) {
                    await this.snapshotTypeService.update(this.snapshotType);
                    toastr.success('Snapshot Type was updated!');
                } else {
                    await this.snapshotTypeService.create(this.snapshotType);
                    toastr.success('New snapshot type was created!');
                }
                this.ea.publish('snapshot-types:updated', this.snapshotType);
                this.controller.ok(this.snapshotType);
            } catch {
                this.isRequesting = false;
            }
        }
        this.isRequesting = false;
    }
}